// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState, useEffect, useCallback } from 'react';
import dateFormat from 'dateformat';
import { useSelector, useDispatch } from 'react-redux'
import { hideModal } from '../actions';
import { ConfirmationDialog } from './Dialog'
import MainMap from './Map'
import { cancelRoute, completeRoute, callRoute } from '../api/githubAPI';
import { setCount, createRoute } from '../actions';
import { navigate } from 'hookrouter';
import { COLOR, loadMarkers, ENLISH_STARTUS } from '../const'
import { COLOR_STARTUS } from '../const'
import styled from '@emotion/styled'
import Clipboard from 'react-clipboard.js';

const RouteDetail = (): JSX.Element => {

  const index = useSelector((state: any) => state.Modal.index)
  const route: any = useSelector((state: any) => state.Route.routes[index])
  const count = useSelector((state: any) => state.Search.count)


  const [showConfirm, setConfirm] = useState(false)
  const [showClipboard, setShowClipboard] = useState(false)
  const dispatch = useDispatch();
  // console.log('RouteDetail', route)
  // if(route.created !== undefined){
  //   const datedilevery = new Date(route.created);
  // }
  useEffect(() => {
    if (route === undefined) {
      dispatch(hideModal())
    }

  }, [route])

  const datedilevery = new Date((route !== undefined) ? route.created : '');


  const copySuccess = useCallback(() => {
    // console.log('copySuccess');
    setShowClipboard(true)
    setTimeout(() => {
      setShowClipboard(false)
    }, 800);
  },[]);

  const handleCancel = async () => {
    // console.log('onSubmit');
    setConfirm(false)
    dispatch(hideModal())
    try {
      await Promise.all([
        cancelRoute(route.routeNo),
        dispatch(setCount(count))
      ])
    } catch (err) {
      console.error(err)
    }

  }

  const handleComleted = async () => {
    try {
      await Promise.all([
        completeRoute(route.routeNo),
        dispatch(setCount(count))
      ])
    } catch (err) {
      console.error(err)
    }
  }

  const handleCallRoute = async () => {
    try {
      await Promise.all([
        callRoute(route.routeNo),
        dispatch(setCount(count)),
        dispatch(hideModal())
      ])
    } catch (err) {
      console.error(err)
    }
  }

  


  const handleReroute = async () => {
    try {
      await Promise.all([
        dispatch(createRoute(route)),
        dispatch(hideModal()),
        navigate('/reroute')
      ])
    } catch (err) {
      console.error(err)
    }
  }

  if (route === undefined) {
    return (<div className={styles.root}>
      <div className={styles.divHeader}>
        <div className={styles.divTitle}>

        </div>
      </div>
    </div>);
  }

  const RouteRow = (routes: Array<any>, status: string) => {
    return (
      <div className={styles.routeRow}>
        <StyledUl status={status} className={styles.circleBar}>
          {new Array(routes.length).fill(null).map((_, index: number) => (
            <li key={index}>
              <div className={styles.columnList}>
                <div className={styles.textCircle}>
                  {routes[index].no}
                  <Clipboard className={styles.btnCoppy} data-clipboard-text={routes[index].no} onClick={copySuccess}>
                    <i className="icon-popup" />
                  </Clipboard>
                </div>
                <div className={styles.textCircle}>
                  {`ผู้ส่งสินค้า:`}{routes[index].contact.name},{routes[index].contact.mobile}
                </div>
                <div className={styles.textAddess}>
                  {routes[index].address}
                  <Clipboard className={styles.btnCoppy} data-clipboard-text={routes[index].address} onClick={copySuccess} >
                    <i className="icon-popup" />
                  </Clipboard>
                </div>
              </div>
            </li>
          ))}
        </StyledUl>

      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.divHeader}>
        <div className={styles.divTitle}>
          <div>
            <div className={styles.textHeader}>DELIVERY DATE</div>
            <div className={styles.textTitle}> {dateFormat(datedilevery, "ddd dd-mm-yyyy")} {dateFormat(datedilevery, "H:MM")}</div>
          </div>
          <div>
            <div className={styles.textHeaderCenter}>ROUTE</div>
            <div className={styles.textTitle}>{route.routeNo}</div>
          </div>
        </div>
        <StyledStatus status={route.status} className={styles.divRowStatus}>
          <div> {ENLISH_STARTUS[route.status]}</div>
        </StyledStatus>
        <div className={styles.divHeaderDetail}>
          <div key='name' className={styles.textHeaderTitle}>DRIVER {(route.driver === undefined ? 'N/A' : route.driver.name)}</div>
          <div key='phone' className={styles.textHeaderTitle}>MOBLILE {(route.driver === undefined ? 'N/A' : route.driver.phone)}</div>
          <div key='type' className={styles.textHeaderTitle}>TYPE {(route.driver === undefined ? 'N/A' : 'มอเตอร์ไซค์')}</div>
        </div>
      </div>

      <div className={styles.scoller}>
        <div className={styles.class}>
          {RouteRow(route.orders, route.status)}
        </div>
        <div className={styles.flexRow}>
          <div className={styles.hedaerNote}>หมายเหตุถึงคนขับ</div>
          <div className={styles.noteDetail}>{(route.remark === undefined ? 'N/A' : route.remark)}</div>
        </div>
        <div className={styles.flexRowPrice}>
          <div className={styles.hedaerPrice}>Price</div>
          <div className={styles.price}>{(route.quotation === undefined ? 'N/A' : route.quotation.totalFee)} </div>
        </div>
        <div className={styles.divRowMap}>
          <div className={styles.divMap}>
            <MainMap zoom={12} route={loadMarkers(route.orders)} />
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.buttonClose} onClick={() => { dispatch(hideModal()) }}>Close</div>
        {(route.status==='COMPLETED' || route.status==='CANCELED'|| route.status==='now')?null:<div className={styles.buttonCancel} onClick={() => { setConfirm(true) }}>CANCEL ROUTE</div>}
        
        {(route.status==='now')?<div className={styles.buttonCall} onClick={() => { handleCallRoute() }}>CALL</div>:null}

        {(route.status==='now')?<div className={styles.buttonCompleted} onClick={() => { handleComleted() }}>COMPLETED</div>:null}
        {/* <div className={styles.buttonCancel} onClick={() => { setConfirm(true) }}>CANCEL</div> */}
        <div className={styles.buttonReroute} onClick={() => { handleReroute() }}>REROUTE</div>
      </div>
      <ConfirmationDialog
        open={showConfirm}
        title={''}
        variant={'danger'}
        description={'Do you want to cancel route ?'}
        onSubmit={handleCancel}
        onClose={() => { setConfirm(false) }}
      />
      <OnClipboard show={showClipboard}>
        Copy to clipboard
      </OnClipboard>
    </div>

  );

}




const styles = {
  root: css`
  position: absolute;
  height: 100%;
  width: 600px;
  top: 0px;
  right: 0px;
  background: #fff;
  box-shadow: -1px 0px 3px rgba(0, 0, 0, 0.13);
  border-radius: 23px 0px 0px 23px;
  `,
  clipboard: css`
    position: absolute;
    height: 50px;
    width: 168px;
    text-align: center;
    top: 50%;
    right: 220px;
    font-weight: bold;
    font-size: 18px;
    line-height: 45px;
    color: #FFFFFF;
    background: #444966;
  border-radius: 13px;
  `,
  columnList: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left:15px;
    padding-bottom:15px;
  `,
  circleBar: css`
  counter-reset: step;
  margin:0;
  padding:0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  li{
    display: flex;
    flex-direction: row;
    float: left;
    position: relative;
    text-align: left;
    list-style: none;
    line-height: 28px;
    &:last-child{
      &:after{
        content: none;
      }
    }
    &:before{
      content:counter(step);
      counter-increment: step;
      min-width: 30px;
      min-height: 30px;
      max-width: 30px;
      max-height: 30px;
      border: 2px solid ${COLOR['BLUE_DARK']};
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: white;
      color: ${COLOR['BLUE_DARK']};
      text-align: center;
      font-size: 16px;
      z-index: 999999;
    }
    &:after{
      content: '';
      position: absolute;
      width:3px;
      min-height: 71%;
      height:75%;
      background: ${COLOR['BLUE_DARK']};
      top: 33px;
      left: 16px;
      z-index: 99999999;
    }
  }
  `,
  class: css`
  display: flex;
  flex-direction: column;
  width: 100%;
  `,
  divHeader: css`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLOR['BLUE_DARK']};
  border-radius: 23px 0px 0px 0px;
  color:#ffffff;
  // font-family: system-ui;
  `,
  textHeader: css`
  color: #FFFFFF;
  font-weight: bold;
  font-size: 18px;
  padding-bottom:10px;
  `,
  textHeaderCenter: css`
  color: #FFFFFF;
  font-weight: bold;
  font-size: 18px;
  padding-bottom:10px;
  text-align: center;
  `,
  textTitle: css`
  color: #FFFFFF;
  font-size: 18px;
  `,
  divTitle: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding:15px 15px;
  `,
  divRowStatus: css`
  display: flex;
  font-weight: bold;
  font-size: 18px;
  color:#ffffff;
  justify-content: center;
  padding: 5px 0;
  background-color: #ffffff;
  `,
  divHeaderDetail: css`
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  padding: 10px 15px;
  justify-content: space-between;
  `,
  textHeaderTitle: css`
  color: ${COLOR['DARK_2']};
  font-weight: bold;
  font-size: 18px;
  `,
  textDetail: css`
  color: ${COLOR['DARK_2']};
  font-size: 18px;
  `,
  divTable: css`
    display: table;
    width: 100%;
    `,
  flexRow: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 15px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    `,
  hedaerNote: css`
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR['BLUE_DARK']};
    // padding: 15px 0 15px 15px;
    `,
  noteDetail: css`
    font-size: 18px;
    color: ${COLOR['DARK_2']};
    text-align: center;
    width: 100%;
    padding:30px 0;
    `,
  flexRowPrice: css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  // width: 100%;
  // padding: 15px;
  `,
  hedaerPrice: css`
  font-size: 20px;
  font-weight: bold;
  color: ${COLOR['BLUE_DARK']};
  padding: 15px;
  `,
  price: css`
  font-size: 20px;
  color: ${COLOR['BLUE_DARK']};
  padding-right: 15px;
  `,
  divRowMap: css`
  display: flex;
  height: 600px;
  width: 600px;
  `,
  divRow: css`
  display: table-row;
  `,
  divCell: css`
  display: table-cell;
    padding: 3px 10px;
    text-align: center
  `,
  divMap: css`
  height: 600px;
  width: 600px;
  background: rgba(0, 181, 0, 0.05);
  `,
  scoller: css`
  height: ${window.innerHeight - 250}px;
  // border: 1px solid;
  // border-radius: 30px;
  // height: 64vh;
  overflow-y: scroll;
  overflow-x: hidden;
  box-sizing: content-box;
  `,
  routeRow: css`;
    height: 100%;
    // width: 600px;
    display: flex;
    flex-direction: column;
    background: rgba(253, 181, 19, 0.05);
    // font-family: system-ui;
    padding:15px;
    `,
  divCircle: css`;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: start;
    margin-bottom: 15px;
    &:last-child{
      margin-bottom: 0px;
    }
    `,
  divText: css`;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left:15px;
    `,
  itemCircle: css`
    height: 100%;
    // width: 90px;
    display: flex;
  justify-content: center;
    `,
  routeCircle: css`
    height: 35px;
    width: 35px;
    border: solid 1px #000;
    border-radius: 35px;
    display: flex;
  justify-content: center;
  align-items: center;
    `,
  btnCoppy: css`
  cursor: pointer;
  padding:0 0 5px 5px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 13px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
   i{
    font-size: 18px;
    color:${COLOR['YELLOW_1']};
   }
   &:focus{
    box-shadow: none;
    outline: none;
   }
  `,
  textCircle: css`
  font-weight: bold;
  font-size: 18px;
  color:${COLOR['DARK_2']};;
    `,
  textAddess: css`
  font-size: 18px;
  color:${COLOR['DARK_2']};;
  // width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  span{
    
  }
    `,
  footer: css`
  position: absolute;
  bottom: 0px;
  height: 92px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 23px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
  `,
  buttonClose: css`
  position: absolute;
    line-height: 40px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 100px;
    height: 40px;
    background: #444966;
    border-radius: 13px;
    bottom: 20px;
    left: 30px;
    text-align: center;
    cursor: pointer;
  `,
  buttonCancel: css`
    position: absolute;
    line-height: 40px;
    color: #E54363;
    font-size: 18px;
    font-weight: bold;
    width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 13px;
    bottom: 20px;
    left: 189px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    text-align: center;
    cursor: pointer;
  `,
  buttonCall: css`
    position: absolute;
    line-height: 40px;
    color: #FFF;
    font-size: 18px;
    font-weight: bold;
    width: 75px;
    height: 40px;
    background: ${COLOR_STARTUS['COMPLETED']};
    border-radius: 13px;
    bottom: 20px;
    left: 150px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    text-align: center;ß
    cursor: pointer;
  `,
  buttonCompleted: css`
    position: absolute;
    line-height: 40px;
    color: ${COLOR_STARTUS['COMPLETED']};
    font-size: 18px;
    font-weight: bold;
    width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 13px;
    bottom: 20px;
    left: 250px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.13);
    text-align: center;ß
    cursor: pointer;
  `,
  buttonReroute: css`
  position: absolute;
    line-height: 40px;
    color: #444966;
    font-size: 18px;
    font-weight: bold;
    width: 150px;
    height: 40px;
    background: #FDB513;
    border-radius: 13px;
    bottom: 20px;
    left: 430px;
    text-align: center;
    cursor: pointer;
  `,
};

type StyledComponentProps = {
  status: string
}

type OnClipboardProps = {
  show: boolean
}

const OnClipboard = styled('div') <OnClipboardProps>`
position: absolute;
height: 50px;
width: 168px;
text-align: center;
top: 50%;
right: 220px;
font-weight: bold;
font-size: 18px;
line-height: 45px;
color: #FFFFFF;
background: #444966;
border-radius: 13px;
display: ${props => (props.show === true) ? 'display' : 'none'};
`
  ;


const StyledUl = styled('ul') <StyledComponentProps>`

  counter-reset: step;
  margin:0;
  padding:0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  li{
    display: flex;
    flex-direction: row;
    float: left;
    position: relative;
    text-align: left;
    list-style: none;
    line-height: 28px;
    &:last-child{
      &:after{
        content: none;
      }
    }
    &:before{
      content:counter(step);
      counter-increment: step;
      min-width: 30px;
      min-height: 30px;
      max-width: 30px;
      max-height: 30px;
      border: 2px solid ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED') {
      return COLOR_STARTUS[props.status]
    }
    return COLOR['BLUE_DARK']
  }};
      display: block;
      margin: 0 auto 10px auto;
      border-radius: 50%;
      line-height: 27px;
      background: ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED') {
      return COLOR_STARTUS[props.status]
    }
    return 'white'
  }};
      color: ${props => {
    if (props.status === 'COMPLETED' || props.status === 'CANCELED') {
      return 'white'
    }
    return COLOR['BLUE_DARK']
  }};
      text-align: center;
      font-size: 16px;
      z-index: 999999999;
    }
    &:after{
      content: '';
      position: absolute;
      width:3px;
      min-height: 71%;
      height:75%;
      background: ${COLOR['BLUE_DARK']};
      top: 33px;
      left: 16px;
      z-index: 99999999;
    }
  }
`;

const StyledStatus = styled('div') <StyledComponentProps>`
    background: ${props => COLOR_STARTUS[props.status]};
  `;


export default RouteDetail;
